import { Button, Stack, useTheme } from '@mui/material';
import { FC } from 'react';
import { useAuth } from 'react-oidc-context';
import { useLocation } from 'react-router';
import Logo from './common/Logo';
import BlockAppBar from './navigation/BlockAppBar';

type NoMetadataPlaceHolderProps = {
  updateMetadata: () => void;
};

const NoMetadataPlaceholder: FC<NoMetadataPlaceHolderProps> = (props) => {
  const { pathname, search } = useLocation();
  const theme = useTheme();
  const auth = useAuth();
  const bgColor = theme.palette.mode === 'dark' ? theme.palette.grey[900] : '#fff';

  return (
    <>
      <BlockAppBar disableButtons />
      <Stack
        width='100%'
        height='100%'
        justifyContent='center'
        alignItems='center'
        direction='column'
        gap={2}
        bgcolor={bgColor}
      >
        <Logo
          sx={{
            fontSize: 400,
            filter: 'grayscale(00%) brightness(90%)',
            opacity: 0.2
          }}
          color='primary'
        />
        <Stack display={'flex'} direction='column' alignItems='center' gap={2} width='100%' flexGrow={2}>
          {!auth.user || !auth.isAuthenticated ? (
            <Button
              variant='contained'
              component='label'
              onClick={() => {
                sessionStorage.setItem('authRedirectUrl', `${pathname}${search}`);
                auth.signinRedirect();
              }}
            >
              {'Log In'}
            </Button>
          ) : (
            <Button variant='contained' component='label' onClick={props.updateMetadata}>
              {'Load Metadata'}
            </Button>
          )}
        </Stack>
      </Stack>
    </>
  );
};

export default NoMetadataPlaceholder;
